import React from 'react';
import { setCurrentView } from 'core/utils';
import { ReceivingEditViewStore } from 'modules/receiving/stores';
import { ReceivingEditTemplate } from 'themes/modules/receiving/pages';

@setCurrentView(rootStore => new ReceivingEditViewStore(rootStore), 'receivingEditViewStore')
class ReceivingEdit extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReceivingEditTemplate {...this.props} />;
	}
}

export default ReceivingEdit;



// WEBPACK FOOTER //
// ./src/modules/receiving/pages/ReceivingEdit.jsx